import styled from 'styled-components';

const RadioInputStyles = styled.div`
    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .input-container {
        margin: 0 0 16px 0;
    }
    .input-label {
        display: block;
        margin-bottom: 4px;
    }
    .option__container {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 16px;
        margin: 16px 0 0 0;
    }
    .option__label {
        cursor: pointer;
        display: grid;
        grid-template-columns: 18px auto;
        grid-gap: 4px;
        max-width: fit-content;
    }
    .option__circle {
        position: relative;
        display: block;
        height: 18px;
        width: 18px;
        border-radius: 100%;
        border: 1px solid var(--gray-400);
    }
    .option__label.active .option__circle::before {
        content: '';
        display: block;
        position: absolute;
        width: 12px;
        height: 12px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: var(--interactive-300);
        border-radius: 100%;
    }
    .option__label.active .option__circle {
        border: 1px solid var(--interactive-300);
    }
    .label__container {
        display: flex;
        align-items: flex-start;
    }
    .required-asterisk {
        margin: 0 4px;
        color: var(--error, #e35141);
    }
    .input-error {
        font-size: 12px;
        color: var(--error, #e35141);
        font-weight: bold;
        margin-top: 10px;
        display: inline-block;
    }
`;
export default RadioInputStyles;
